import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import CorporateStays from "@/pages/CorporateStays";
import StayWithUs from "@/pages/StayWithUs";
import AreaPage from "@/pages/AreaPage";
import Assessment from "@/pages/Assessment";
import Faqs from "@/pages/Faqs";
import Admin from "@/pages/Admin";

function ScrollAndSmooth() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      lenis.destroy();
      cancelAnimationFrame(rafId);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App bg-cream text-charcoal font-sans">
      <BrowserRouter>
        <ScrollAndSmooth />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/corporate-stays" element={<CorporateStays />} />
          <Route path="/stay" element={<StayWithUs />} />
          <Route path="/areas/:slug" element={<AreaPage />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/admin/leads" element={<Admin />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#0F261C", color: "#FAF9F5", border: "1px solid rgba(122,154,139,0.3)" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
